<template>
    <div>
        <!-- <div id="loading" v-show="showLoading">
            <img src="../assets/loading.gif" alt="Loading...">
        </div> -->
        <div id="message"></div>
        <div class="container">
            <h1 class="title">{{ detail.name }}</h1>
            <p class="description">{{ detail.description }}</p>
            <el-divider style="margin-bottom:1px"></el-divider>
            <div class="checkbox-area">
                <div class="checkbox-line" v-for="tagGroup in tagGroups" :key="tagGroup.name">
                    <div class="checkbox-left">{{ tagGroup.name }}：</div>
                    <div class="checkbox-right">
                        <el-checkbox-group v-for="tag in tagGroup.tags" v-model="input.tags" :key="tag.name">
                            <el-checkbox :label="tag.value" border size="mini">{{ tag.name }}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                </div>
            </div>
            <div id="form" class="centerBox">
                <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 50 }" :placeholder="placeholder"
                    v-model="input.content" id="input" style="font-size: 16px; " maxlength="2048" show-word-limit />
                <div style="height:10px;width: 100%; ">
                    <button class="cleanButton" @click="clean">🗑️ 清空</button>
                </div>
                <el-button type="primary" @click="submit" :loading="showLoading">提交</el-button>
            </div>
            <div id="resultBox" class="centerBox" v-show="markdownText">
                <div id="result" disabled="disabled">{{ markdownText }}</div>
                <el-button @click="copy">一键复制</el-button>
            </div>
        </div>
    </div>
</template>
  
<script>
import { ChatAPI } from '../api/chat'
import { StreamAPI } from '../api/stream'

export default {
    name: 'Tool',
    data() {
        return {
            input: {
                keyword: "",
                content: "",
                tags: []
            },
            detail: {
                keyword: "",
                name: "",
                description: "",
                input_demo: ""
            },
            placeholder: "选择标签并输入相关信息生成文案，输入示例：",
            tagGroups: [], // [{"name":"其他","tags":[{"name":"emoji表情","value":"emoji表情"}]}]
            showLoading: false,
            markdownText: ''
        }
    },
    created() {
        const keyword = this.$route.params.keyword
        this.input.keyword = keyword

        // 查询场景详情
        ChatAPI.querySceneDetail(keyword).then(resp => {
            // console.info("detail:" + JSON.stringify(resp))
            this.detail = resp
            this.placeholder = this.placeholder + resp.input_demo
        })

        // 查询标签
        ChatAPI.queryTagGroup(keyword).then(resp => {
            this.tagGroups = resp
            // console.info("tagGroups:" + JSON.stringify(resp))
        })


    },
    methods: {
        querySceneList() {
            async () => {
                const resp = await ChatAPI.querySceneList()
                data.themes = resp
            }
        },
        clean() {
            this.input.content = ''
        },
        submit() {
            if (this.input.content.length === 0) {
                this.$message({
                    message: '问题不能为空',
                    type: 'warning'
                });
                return
            }
            this.markdownText = ''
            this.showLoading = true
            StreamAPI.chat(this.input, resp => {
                this.markdownText = resp
            }).then(resp => {
                this.showLoading = false;
            }).catch(error => {
                console.log(error)
                this.showLoading = false;
            })
        },
        copy() {
            this.$copyText(this.markdownText).then(e => {
                this.$message({
                    message: '已复制到剪切板',
                    type: 'success'
                })
            })
        }
    },
    mounted() {
        const input = document.getElementById('input');
        input.addEventListener('keydown', (event) => {
            // console.info(event)
            if (event.ctrlKey && event.key === 'Enter') {
                this.submit();
            }
        });
    }
}
</script>
  
<style scoped>
body {
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    height: 100vh;
    background-color: #f2f2f2;
}

.container {
    background-color: #fff;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
    padding: 20px;
    border-radius: 10px;
    width: 800px;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    margin: 0 auto;
    box-sizing: border-box;
}

@media only screen and (max-width: 768px) {
    .container {
        max-width: 100%;
    }
}

.title {
    font-size: 30px;
    font-weight: bold;
    margin: 0;
    margin-bottom: 10px;
    text-align: center;
}

.description {
    font-size: 18px;
    margin: 0;
}

.checkbox-area {
    width: 100%;
    margin: 0 0 10px 0;
}

.checkbox-line {
    width: 100%;
    margin: 6px 0;
    display: flex;
    /* justify-content: center; */
}

.checkbox-left {
    width: auto;
    margin: 0;
    height: auto;
    display: block;
    white-space: nowrap;
}

.checkbox-right {
    display: flex;
    flex-wrap: wrap;
    max-width: calc(100% - 100px);
}

.el-checkbox-group {
    height: auto;
    width: auto;
    margin: 1px 5px;
}



.centerBox {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 10px;
    width: 100%;
}

.cleanButton {
    float: right;
    margin-right: 5px;
    margin-top: 5px;
    height: 20px;
    background-color: #90939988;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}

.cleanButton:hover {
    background-color: #909399;
}

/* button {
    background-color: #4CAF50;
    color: white;
    border: none;
    border-radius: 5px;
    padding: 10px 20px;
    font-size: 16px;
    cursor: pointer;
    margin-top: 10px;
}

button:hover {
    background-color: #3e8e41;
} */

#result {
    margin-top: 20px;
    margin-bottom: 10px;
    width: 100%;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 10px;
    font-size: 16px;
    white-space: pre-wrap;
    word-wrap: break-word;
    overflow-y: auto;
}

/* #loading {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.5);
    z-index: 9999;
} */

/* #loading img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
} */
</style>
  


// WEBPACK FOOTER //
// src/components/Tool.vue